import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

interface PageProps {
	children?: React.ReactNode;
}

type BodyProps = PageProps & BoxProps;

const Body: React.FC<BodyProps> = ({
	children,
	...props
}: BodyProps): React.JSX.Element => {
	return (
		<Box component="main" id="body-container" {...props}>
			{children}
		</Box>
	);
};

export default Body;
